import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Label, Input, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import CompanyContext from '../../../auth/CompanyContext'; import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNoteSticky } from '@fortawesome/free-solid-svg-icons'
class LandingRecentActivity extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);
    this.state = {
      marketingActivities: [],
      isLoading: false,
      showMyActivityOnly: true,
      selectedNote: null,
      showModal: false
    }

    this.abortController = null;
  }

  componentDidMount = () => {
    this.getMarketingActivities();
  };

  getMarketingActivities = (cb) => {

    if (this.abortController) {
      this.abortController.abort();
    }

    // Create a new controller for the new request
    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    this.setState({
      isLoading: true
    }, () => {
      fetch('/api/marketing2Activities/' + (this.state.showMyActivityOnly ? this.props.user : ''), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.props.clientToken,
          'X-Database': this.context.company
        },
        signal
      })
        .then(results => results.json())
        .then(results => {
          this.setState({
            marketingActivities: results.data,
            isLoading: false
          }, () => {
            if (cb != null) cb();
          });
        })
        .catch(err => {
          if (err.name === 'AbortError') {
            return;
          }
          console.error('Fetch error:', err);
          this.setState({ isLoading: false });
        });
    })
  }

  showModal = (noteObj) => {
    this.setState({
      selectedNote: noteObj,
      showModal: true
    })
  }

  render() {
    const rawText = this.state.selectedNote?.comment || ''; // `From: Diane Herrera <dherrera@cssisolutions.com>\nSent: Wednesday, March 19, 2025 2:57 PM\nTo: Mike Herrera <mherrera@cssisolutions.com>\n\nI did that already.`;
    const lines = rawText.split("\n");
    return (
      <>
        <Modal isOpen={this.state.showModal} size="xl">
          {this.state.selectedNote != null && <>
            <ModalHeader toggle={() => this.setState({ showModal: false })}>
              Note: {this.state.selectedNote?.type} ({this.state.selectedNote?.primaryBusinessName})
            </ModalHeader>
            <ModalBody>
              <div>{lines.map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}</div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => this.setState({ showModal: false })}
              >
                Close
              </Button>
            </ModalFooter>
          </>}
        </Modal >
        <Card className='w-100 m-0'>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h4>Recent Activity</h4>
            <Col className="col-xs-5 text-right">
              <Label>
                <Input
                  type="checkbox"
                  name="showMyActivityOnly"
                  checked={this.state.showMyActivityOnly}
                  onChange={() => {
                    this.setState({
                      showMyActivityOnly: !this.state.showMyActivityOnly
                    }, () => this.getMarketingActivities())
                  }}
                />
                Show My Activity Only
              </Label>
            </Col>
            {this.props.icon}
          </CardHeader>
          <CardBody className='p-0'>
            <ReactTable
              data={this.state.marketingActivities}
              loading={this.state.isLoading}
              columns={[
                {
                  Header: 'Category',
                  accessor: 'type',
                  headerStyle: { textAlign: 'left' },
                  filterable: true,
                  width: 140
                },
                {
                  Header: 'Company / Contact',
                  accessor: 'company',
                  filterable: true,
                  headerStyle: { textAlign: 'left' },
                  minWidth: 200,
                  Cell: row =>
                  (<Link
                    onClick={() => {
                      if (row.original['contact']) return;
                      localStorage.setItem('demographicsActiveTab', row.original['opportunity'] === 1 ? 3 : 1)
                    }}
                    to={{
                      pathname: row.original.contact ? '/contacts/' + row.original.contactGUID : '/demographics/' + row.original['secID'],
                      state: {}
                    }}
                  >{row.original.contact ? `${row.original.contact} ${row.original.company ? '(' + row.original.company + ')' : ''}` : row.original['company']}</Link>)
                },
                {
                  Header: 'User',
                  accessor: 'name',
                  filterable: true,
                  headerStyle: { textAlign: 'left' },
                },
                {
                  Header: 'Date',
                  accessor: 'timestamp',
                  filterable: true,
                  width: 90,
                  style: { textAlign: 'right' },
                  headerStyle: { textAlign: 'right' },
                  Cell: (props) => {
                    return <>{this.props.formatDate(props.value)}</>
                  }
                },
                {
                  Header: 'Note',
                  accessor: 'comment',
                  filterable: false,
                  width: 60,
                  Cell: (props) => {
                    return <>{props.original['comment'] ?
                      <Button
                        size="sm"
                        color="dark"
                        outline
                        onClick={() => this.showModal({
                          comment: props.original['comment'],
                          type: props.original['type'],
                          primaryBusinessName: props.original.contact ? `${props.original.contact} ${props.original.company ? '(' + props.original.company + ')' : ''}` : props.original['company']
                        })}
                        className='font-weight-bold text-right justify-content-end'
                      ><FontAwesomeIcon icon={faNoteSticky} /></Button>
                      : ''}</>
                  }
                },
              ]}
              pageSize={this.props.pageSize}
              onPageSizeChange={this.props.setPageSize}
              showPagination={true}
              defaultFilterMethod={this.props.filterCaseInsensitive}
            />
          </CardBody>
        </Card >
      </>
    );

  }
}

export default LandingRecentActivity;
